<!-- VISITAS FORMULARIO STEP 6 -->
<strong
  >¡¡¡Felicidades!!!, ya fuiste autorizado para tu crédito, ya estas más cerca
  de tener tu propio coche.</strong
>
<p class="text-form">
  Por favor, carga los siguientes documentos e indicanos un horario en el que
  podamos visitarte y no interfiera con tus labores.
</p>

<small class="text-form"
  >Lunes a domingos dentro de los siguientes horarios:</small
>
<form autocomplete="off" class="form" [formGroup]="formStepSecondaryDocuments">
  <div class="row">
    <!-- OPCION 1 DIA 1 -->
    <mat-form-field appearance="fill">
      <mat-label>Opción día de la semana 1</mat-label>
      <mat-select (selectionChange)="checkEvent()" formControlName="weekDayOne">
        <mat-option *ngFor="let day of dayVisit" [value]="day.value">
          {{ day.description }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepSecondaryDocuments.controls['weekDayOne'].invalid &&
          formStepSecondaryDocuments.controls['weekDayOne'].touched
        "
      >
        <span
          *ngIf="
            formStepSecondaryDocuments.controls['weekDayOne'].errors &&
            formStepSecondaryDocuments.controls['weekDayOne'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>

    <!-- OPCION 2 DIA 2 -->
    <mat-form-field appearance="fill">
      <mat-label>Opción día de la semana 2</mat-label>
      <mat-select (selectionChange)="checkEvent()" formControlName="weekDayTwo">
        <mat-option *ngFor="let day of dayVisit" [value]="day.value">
          {{ day.description }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepSecondaryDocuments.controls['weekDayTwo'].invalid &&
          formStepSecondaryDocuments.controls['weekDayTwo'].touched
        "
      >
        <span
          *ngIf="
            formStepSecondaryDocuments.controls['weekDayTwo'].errors &&
            formStepSecondaryDocuments.controls['weekDayTwo'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <!-- HORARIO 1 -->
    <mat-form-field appearance="fill">
      <mat-label>Horario opción día de la semana 1</mat-label>
      <mat-select
        (selectionChange)="checkEvent()"
        formControlName="timeRangeOne"
      >
        <mat-option *ngFor="let time of timeLapse" [value]="time.value">
          {{ time.description }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepSecondaryDocuments.controls['timeRangeOne'].invalid &&
          formStepSecondaryDocuments.controls['timeRangeOne'].touched
        "
      >
        <span
          *ngIf="
            formStepSecondaryDocuments.controls['timeRangeOne'].errors &&
            formStepSecondaryDocuments.controls['timeRangeOne'].errors[
              'required'
            ]
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>

    <!-- HORARIO 2 -->
    <mat-form-field appearance="fill">
      <mat-label>Horario opción día de la semana 2</mat-label>
      <mat-select
        (selectionChange)="checkEvent()"
        formControlName="timeRangeTwo"
      >
        <mat-option *ngFor="let time of timeLapse" [value]="time.value">
          {{ time.description }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepSecondaryDocuments.controls['timeRangeTwo'].invalid &&
          formStepSecondaryDocuments.controls['timeRangeTwo'].touched
        "
      >
        <span
          *ngIf="
            formStepSecondaryDocuments.controls['timeRangeTwo'].errors &&
            formStepSecondaryDocuments.controls['timeRangeTwo'].errors[
              'required'
            ]
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
  </div>
</form>

<div class="container">
  <p>
    En caso de no haberlo subido en el paso Documentos Principales,adjunta tu
    INE, Licencia y Comprobante de Domicilio,
    <strong>junto al resto de documentos restantes.</strong>
  </p>
  <br />
  <!-- TABLA -->
  <ng-container *ngFor="let option of documentsCategory">
    <table class="table">
      <thead>
        <tr>
          <th>
            <strong>{{ option.helpText }} </strong>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of option.documents">
          <td
            *ngIf="
              doc.name != 'DOCUMENTOS AVAL (Solo si se lo solicitan)' &&
              doc.name != 'ACTA DE MATRIMONIO (Solo si está casada/o)'
            "
          >
            {{ doc.name }} (*)
          </td>
          <td
            *ngIf="
              doc.name === 'DOCUMENTOS AVAL (Solo si se lo solicitan)' ||
              doc.name === 'ACTA DE MATRIMONIO (Solo si está casada/o)'
            "
          >
            {{ doc.name }}
          </td>
          <td class="buttons-table-position">
            <ng-container *ngIf="doc.spinner; else publish">
              <mat-spinner [diameter]="20"></mat-spinner>
            </ng-container>
            <ng-template #publish>
              <ng-container *ngIf="!doc.uploaded; else uploaded">
                <button
                  mat-icon-button
                  style="color: #0ebc7f"
                  matTooltip="Modelo del documento"
                  (click)="openViewModelDocuments(doc)"
                  *ngIf="doc.exceptDocument"
                >
                  <mat-icon>help</mat-icon>
                </button>
                <div *ngIf="doc.downloadCurp">
                  <button
                    mat-icon-button
                    style="color: #0ebc7f"
                    matTooltip="Descargar CURP"
                    (click)="isOpen = !isOpen"
                    type="button"
                    cdkOverlayOrigin
                    #trigger="cdkOverlayOrigin"
                  >
                    <mat-icon>help</mat-icon>
                  </button>
                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="trigger"
                    [cdkConnectedOverlayOpen]="isOpen"
                  >
                    <p class="example-list">
                      Si no recuerdas tu CURP búscalo desde
                      <a href="http://www.gob.mx/curp/" target="_blank"
                        >aquí.</a
                      >
                    </p>
                  </ng-template>
                </div>

                <label
                  mat-icon-button
                  matTooltip="Tomar fotografía"
                  style="color: #0ebc7f"
                  *ngIf="doc.canOpenCamera && cameraMovil"
                  for="{{ doc.id }}-'camera'"
                >
                  <mat-icon>camera_alt</mat-icon>
                </label>
                <input
                  type="file"
                  accept="image/*"
                  capture="enviroment"
                  id="{{ doc.id }}-'camera'"
                  (change)="loadDocument($event, doc)"
                  *ngIf="doc.canOpenCamera && cameraMovil"
                  style="display: none"
                />
                <label
                  mat-icon-button
                  matTooltip="Subir documento"
                  for="{{ doc.id }}"
                  style="color: #0ebc7f"
                >
                  <mat-icon class="button-upload"> publish</mat-icon>
                </label>
                <input
                  type="file"
                  id="{{ doc.id }}"
                  name="avatar"
                  accept="image/png, image/jpeg, application/pdf,.rar"
                  hidden
                  (change)="loadDocument($event, doc)"
                />
              </ng-container>
              <ng-template #uploaded
                ><button
                  mat-icon-button
                  matTooltip="Ver documento"
                  color="primary"
                  (click)="viewDocuments(doc)"
                >
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
                <button
                  *ngIf="!doc.delete"
                  mat-icon-button
                  matTooltip="Eliminar documento"
                  color="primary"
                  (click)="confirmDeleteDocuments(doc)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
